'use client';

import type { ReactNode } from "react";
import { UserProvider } from "@/context/UserContext";
import { QuickEditorProvider } from "@/context/QuickEditorContext";
import { LayoutProvider } from "@/context/LayoutContext";
import { CategoryFilterProvider } from "@/context/CategoryFilterContext";

interface AppProvidersProps {
    readonly children: ReactNode;
}

export default function AppProviders({ children }: AppProvidersProps) {
    return (
        <UserProvider>
            <LayoutProvider>
                <CategoryFilterProvider>
                    <QuickEditorProvider>{children}</QuickEditorProvider>
                </CategoryFilterProvider>
            </LayoutProvider>
        </UserProvider>
    );
}
